import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Diagnose",
    desc: "We map your positioning, audience segments, and competitive differentiators before touching copy.",
  },
  {
    n: "02",
    title: "Produce",
    desc: "ASO metadata, ad copy, email flows, and a full viral video script package — generated instantly.",
  },
  {
    n: "03",
    title: "Protect",
    desc: "Every recommendation respects your budget: $5-$10/day tests, never high upfront ad spend.",
  },
  {
    n: "04",
    title: "Propagate",
    desc: "Winning hooks get reused across your entire app portfolio — isolated frameworks, shared wins.",
  },
];

const ManifestoChapters = () => {
  return (
    <section className="relative py-24 sm:py-32 px-6 lg:px-12">
      <div className="max-w-5xl mx-auto space-y-24">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.n}
            data-testid={`home-manifesto-chapter-${i}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="relative grid grid-cols-1 md:grid-cols-[auto_1fr] gap-8 items-start"
          >
            <span className="font-display text-7xl sm:text-8xl font-black text-white/10 leading-none select-none">
              {c.n}
            </span>
            <div className="pt-2 md:pt-6">
              <h3 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mb-3">{c.title}</h3>
              <p className="text-base text-white/60 max-w-xl leading-relaxed">{c.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default ManifestoChapters;
